var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotifications = function SvgNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.182,
    height: 38.5,
    viewBox: "0 0 28.182 38.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(1288.831 -264.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M-1270.616,298.555a4.179,4.179,0,0,1-4.124,3.5,4.177,4.177,0,0,1-4.122-3.5",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M-1274.534,271.674",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M-1274.534,271.674",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M-1274.917,271.674a10.567,10.567,0,0,1,3.069.438c4.682,1.53,4.46,7.039,4.46,7.039,0,7.983,5.475,10.821,5.475,10.821,0,2.8.014,4.966.014,4.966h-25.682s.015-2.165.015-4.966c0,0,5.475-2.838,5.475-10.821,0,0-.222-5.509,4.459-7.039a10.58,10.58,0,0,1,3.07-.438h0",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M-1270.731,279.016m-5.862-3.725c-2.148.7-2.16,3.449-2.155,3.76,0,.045,0,.055,0,.1",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M-1274.945,271.674h.014",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M-1271.932,268.867a2.808,2.808,0,0,1-2.808,2.807,2.808,2.808,0,0,1-2.808-2.807,2.808,2.808,0,0,1,2.808-2.809A2.808,2.808,0,0,1-1271.932,268.867Z",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications.f72f8bd8.svg";
export { ForwardRef as ReactComponent };